import { render, staticRenderFns } from "./TransformerConfiguration.vue?vue&type=template&id=f24e2b0e"
import script from "./TransformerConfiguration.vue?vue&type=script&lang=js"
export * from "./TransformerConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports